module.exports = __webpack_public_path__ + "img/data_ingestion.9e358e01.svg";